import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";
const clientToken = secureStorage.getItem("clientToken");

export const hotelBooking = (
  setHotelData,
  Page,
  Limit,
  setPageData,
  setIsLoading,
  id,
) => {
  setIsLoading(true);
  axiosInstance
    .get(`/client/hotel/all/${id}?page=${Page}&limit=${Limit}`, {
      headers: {
        Authorization: `Bearer ${clientToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setHotelData(res.data.data);
      setPageData(res.data.totalPage);
      setIsLoading(false);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
export const makePaid = (FormData, companyId, setIsLoading) => {
  setIsLoading(true);
  axiosInstance
    .post(`/client/hotel/pay-full/${companyId}`, FormData, {
      headers: {
        Authorization: `Bearer ${clientToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Payment completed successfully") {
        toast.success("Payment successful");
        window.location.reload();
      }
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
